<template>
    <span class="StatusIndicator" :class="indicatorClasses">
        <span class="StatusIndicator__beacon"></span>
    </span>
</template>

<style lang="less" type="text/less">
@import '~dashboard-less/variables';

.StatusIndicator {
    position: relative;
    margin: auto 16px auto 8px;
}

.StatusIndicator__beacon {
    position: absolute;
    top: 50%;
    left: 50%;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    -webkit-transform: translateX(-50%) translateY(-50%);
}

.StatusIndicator--beacon-active .StatusIndicator__beacon:before {
    position: absolute;
    content: '';
    height: 16px;
    width: 16px;
    left: 0;
    top: 0;
    background-color: transparent;
    border-radius: 50%;
    animation: beacon 4s infinite linear;
}

.StatusIndicator--default .StatusIndicator__beacon {
    background-color: @color-gray-light;

    &:before {
        box-shadow: 0px 0px 2px 2px darken(@color-gray-light, 20%);
    }
}

.StatusIndicator--success .StatusIndicator__beacon {
    background-color: @brand-success;

    &:before {
        box-shadow: 0px 0px 2px 2px darken(@brand-success, 20%);
    }
}

.StatusIndicator--warning .StatusIndicator__beacon {
    background-color: @brand-warning;

    &:before {
        box-shadow: 0px 0px 2px 2px darken(@brand-warning, 20%);
    }
}

.StatusIndicator--danger .StatusIndicator__beacon {
    background-color: @brand-danger;

    &:before {
        box-shadow: 0px 0px 2px 2px darken(@brand-danger, 20%);
    }
}
</style>

<script type="text/babel">
export default {
    props: ['type', 'beacon'],

    data() {
        return {}
    },

    computed: {
        indicatorClasses() {
            return (
                'StatusIndicator--' +
                this.type +
                (this.beacon ? ' StatusIndicator--beacon-active' : '')
            )
        },
    },

    created() {},

    methods: {},
}
</script>
